import React from 'react';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useAppSelector } from 'src/app/hooks';

import { Layout } from 'src/styles';

export default function TopBarView() {
  const { title, key, id } = useAppSelector((state) => state.page);
  const navigate = useNavigate();

  const handleBack = () => {
    if (!key) {
      navigate(-1);
      return;
    }
    navigate(['perfil', 'entreposto'].includes(key) ? '/' : `/${key}`);
  };
  const handleEdit = () => {
    if (!key || !id) {
      return;
    }
    navigate(`/${key}/edit/${id}`);
  };
  return (
    <AppBar position="fixed" elevation={0}>
      <Toolbar>
        <Box sx={Layout.topBarWrapper}>
          <Box sx={Layout.topBar}>
            <IconButton edge="start" color="inherit" aria-label="voltar" onClick={handleBack}>
              <ArrowBackIcon />
            </IconButton>
            <IconButton edge="end" color="inherit" aria-label="editar" onClick={handleEdit}>
              <EditIcon />
            </IconButton>
          </Box>
          <Typography variant="h6" component="div" sx={Layout.topBarTitle}>
            {title}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
